import { Controller } from "stimulus";
import ConfettiGenerator from "confetti-js";

// Set key so that it only shows once during a session
const SESSION_KEY = "CHRISTMAS_CONFETTI_SHOWN";

export default class extends Controller {
    static targets = ["confetti"];

    connect() {
        // Check if the confetti has been shown
        this.hasShown = sessionStorage.getItem(SESSION_KEY);
        if (!this.hasShown) {
            // Wait half a second to show the confetti
            setTimeout(() => {
                this.showConfetti();
            }, 500);
        }

        this.addShowButton();
    }

    showConfetti() {
        const confettiSettings = { ...this.defaultConfig(), target: this.confettiTarget };
        const confetti = new ConfettiGenerator(confettiSettings);
        confetti.render();

        // Set the session key so that it doesn't show again
        sessionStorage.setItem(SESSION_KEY, true);
    }

    addShowButton() {
        // Make sure the button isn't already there
        if (document.getElementById("christmas-show-confetti")) {
            return;
        }

        const button = document.createElement("button");
        button.id = "christmas-show-confetti";
        
        // Create image tag
        const image = document.createElement("img");
        image.src = this.getImageSource();
        image.alt = "show confetti";
        image.style.width = "24px";
        image.style.height = "24px";

        // Append image to button
        button.appendChild(image);

        // Append button to body
        const target = document.getElementById("footer-links");
        target.appendChild(button);

        // Add event listener
        button.addEventListener("click", () => {
            this.showConfetti();
        });
    }

    getImageSource() {
        return this.confettiTarget.getAttribute("data-image-src");
    }

     defaultConfig() {
        const imageSrc = this.getImageSource();
        return{
            "max": "200",
            "size": "1.2",
            "animate": true,
            "props": [{"type": "svg", "src": imageSrc, "weight": 0.1, "size": 32}, "line", "circle"],
            "colors": [[255, 0, 0], [0, 255, 0]], // Red and Green for Christmas
            "clock": "50",
            "rotate": true,
            "start_from_edge": true,
            "respawn": false,
        };
    }

}
